import { sportingAPI } from 'services/sporting/api';

export const getNewRestaurantApplicationsCount = async (): Promise<number> => {
  const applicationIds = await sportingAPI.service.getNewRestarauntClaimsCount();

  return applicationIds.length;
};
